// extracted by mini-css-extract-plugin
export var clips = "index-module--clips--UbVUo";
export var clipsContainer = "index-module--clips-container--7H4DT";
export var clip1 = "index-module--clip-1--dpL8e";